exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.meter_green_1TDyl {\r\n    fill: rgb(171, 220, 170);\r\n    stroke: rgb(174, 211, 168);\r\n}\r\n\r\n.meter_yellow_YVGHr {\r\n    fill: rgb(251, 219, 130);\r\n    stroke: rgb(239, 212, 134);\r\n}\r\n\r\n.meter_red_S3fdX {\r\n    fill: rgb(251, 194, 142);\r\n    stroke: rgb(235, 189, 142);\r\n}\r\n\r\n.meter_mask-container_m3uVt {\r\n    position: relative;\r\n}\r\n\r\n.meter_mask_1s9vE {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    transform-origin: top;\r\n    will-change: transform;\r\n    background: var(--ui-primary);\r\n    opacity: 0.75;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"green": "meter_green_1TDyl",
	"yellow": "meter_yellow_YVGHr",
	"red": "meter_red_S3fdX",
	"mask-container": "meter_mask-container_m3uVt",
	"maskContainer": "meter_mask-container_m3uVt",
	"mask": "meter_mask_1s9vE"
};